import { faEllipsis, faFolderArrowDown, faPenToSquare, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { CompGroup } from "userful-chronos-app-common-js/dist/models/group/Groups";
import DeleteFolder, { DeleteFolderHandle } from "../Table/folder/DeleteFolder";
import Button from "../button/Button";
import Dropdown from "../dropdown/Dropdown";
import { IDropdownItem } from "../dropdown/dropdownUtils";

interface IProps {
    value: CompGroup;
    comps: CompGroup[];
    parent?: CompGroup;
    trigger?: React.ReactNode;
    onMoveOut: () => void;
    onDelete: (id: string, recursive: boolean) => void;
    onEdit: (value: CompGroup, parent?: CompGroup) => void;
}

export default function FolderActionsMenu({ value, comps, trigger, onMoveOut, onDelete, onEdit, parent }: IProps) {
    const { t } = useTranslation();
    const deleteFolderRef = useRef<DeleteFolderHandle>(null);

    const dropdownItems: IDropdownItem[] = [
        { id: "edit-folder", icon: <FontAwesomeIcon icon={faPenToSquare} />, title: t("Shared.edit") },
        { id: "move", icon: <FontAwesomeIcon icon={faFolderArrowDown} />, title: t("Shared.move") },
        { id: "delete-folder", icon: <FontAwesomeIcon icon={faTrashAlt} />, title: t("Shared.delete") },
    ];

    const handleDropdownChange = (item: IDropdownItem) => {
        switch (item.id) {
            case "edit-folder":
                // Defer edit handling to consumer
                onEdit?.(value, parent);
                break;
            case "move":
            case "move-out":
                onMoveOut();
                break;
            case "delete-folder":
                deleteFolderRef.current?.open();
                break;
            default:
                break;
        }
    };

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <Dropdown
                items={dropdownItems}
                onChange={handleDropdownChange}
                trigger={
                    trigger ? (
                        trigger
                    ) : (
                        <Button
                            className="source-actions-menu-toggle"
                            variant="ghost"
                            size="small"
                            iconOnly
                            aria-label={t("Shared.actions")}
                            style={{ width: 36 }}
                        >
                            <div className="userful-dropdown-icon-wrapper">
                                <FontAwesomeIcon icon={faEllipsis} />
                            </div>
                        </Button>
                    )
                }
                usePortal
            />

            <DeleteFolder ref={deleteFolderRef} folders={[value]} onDelete={onDelete} type="dropdown" hideTrigger />
        </div>
    );
}
